<template>
    		<!-- Our Latest Blog -->
		<section class="latest-blog-five"> 
			<div class="container"> 
				<div class="row">
					<div class="col-md-12 text-center">
						<div class="section-heading heading-five aos" data-aos="fade-up">
							<h2>Our Latest Blog</h2>
						</div>	
					</div>
				</div>
				<div class="row">
					<div class="col-lg-6 col-md-6 d-flex aos" data-aos="fade-up">
						<div class="articles-grid w-100">
							<div class="articles-info">
								<div class="articles-left">
									<a href="javascript:void(0);">
										<div class="articles-img">
											<img src="@/assets/img/blog/blog-16.jpg" class="img-fluid" alt="">
										</div>
									</a>
								</div>
								<div class="articles-right">
									<div class="articles-content">
										<ul class="articles-list nav">
											<li>
												<i class="feather-user"></i> John Doe
											</li>
											<li>
												<i class="feather-calendar"></i> 13 Aug, 2023
											</li>
										</ul>
										<h4>
											<a href="javascript:void(0);">Lorem ipsum dolor amet, adipiscing ut labore </a>
										</h4>
										<p>Sed perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium</p>
										<a href="javascript:void(0);" class="btn articles-read-more">Read More<i class="feather-arrow-right ms-2"></i></a>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="col-lg-6 col-md-6 d-flex aos" data-aos="fade-up">
						<div class="articles-grid w-100">
							<div class="articles-info">
								<div class="articles-left">
									<a href="javascript:void(0);">
										<div class="articles-img">
											<img src="@/assets/img/blog/blog-17.jpg" class="img-fluid" alt="">
										</div>
									</a>
								</div>
								<div class="articles-right">
									<div class="articles-content">
										<ul class="articles-list nav">
											<li>
												<i class="feather-user"></i> Darren Elder
											</li>
											<li>
												<i class="feather-calendar"></i> 10 Sep, 2023
											</li>
										</ul>
										<h4>
											<a href="javascript:void(0);">Lorem ipsum dolor amet, adipiscing ut labore </a>
										</h4>
										<p>Sed perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium</p>
										<a href="javascript:void(0);" class="btn articles-read-more">Read More<i class="feather-arrow-right ms-2"></i></a>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="col-lg-6 col-md-6 d-flex aos" data-aos="fade-up">
						<div class="articles-grid w-100">
							<div class="articles-info">
								<div class="articles-left">
									<a href="javascript:void(0);">
										<div class="articles-img">
											<img src="@/assets/img/blog/blog-18.jpg" class="img-fluid" alt="">
										</div>
									</a>
								</div>
								<div class="articles-right">
									<div class="articles-content">
										<ul class="articles-list nav">
											<li>
												<i class="feather-user"></i> Ruby Perrin
											</li>
											<li>
												<i class="feather-calendar"></i> 30 Oct, 2023
											</li>
										</ul>
										<h4>
											<a href="javascript:void(0);">Lorem ipsum dolor amet, adipiscing ut labore </a>
										</h4>
										<p>Sed perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium</p>
										<a href="javascript:void(0);" class="btn articles-read-more">Read More<i class="feather-arrow-right ms-2"></i></a>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="col-lg-6 col-md-6 d-flex aos" data-aos="fade-up">
						<div class="articles-grid w-100">
							<div class="articles-info">
								<div class="articles-left">
									<a href="javascript:void(0);">
										<div class="articles-img">
											<img src="@/assets/img/blog/blog-19.jpg" class="img-fluid" alt="">
										</div>
									</a>
								</div>
								<div class="articles-right">
									<div class="articles-content">
										<ul class="articles-list nav">
											<li>
												<i class="feather-user"></i> John Doe
											</li>
											<li>
												<i class="feather-calendar"></i> 22 Sep 2023
											</li>
										</ul>
										<h4>
											<a href="javascript:void(0);">Lorem ipsum dolor consectetur adipiscing  </a>
										</h4>
										<p>Sed perspiciatis unde omnis iste voluptatem accusantium doloremque laudantium, totam rem aperiam</p>
										<a href="javascript:void(0);" class="btn articles-read-more">Read More<i class="feather-arrow-right ms-2"></i></a>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>	
		</section>	
		<!-- Our Latest Blog -->
		
		<!-- Stay Tuned -->
		<section class="stay-tuned stay-turn-five">
			<div class="container">
				<div class="stay-with-us">
					<h3>Stay Tuned With Us</h3>
					<p>Subcribe to our newletter and never miss our latest news and promotions. Our newsletter is sent once a week, every thursday.</p>
					<form>
						<div class="form-group">
							<div class="group-img">
								<i class="feather-mail"></i>
								<input type="text" class="form-control" placeholder="Enter Email Address">
							</div>							
						</div>
						<button class="btn btn-primary" type="submit"> Subscribe</button>	 						
					</form>					
				</div>
			</div>
		</section>
		<!-- Stay Tuned -->
    </template>